import React, { useEffect, useState }  from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './ProductARViewer.css';
import { getUSDZBaseURL, getGLBBaseURL, getUSDZAIBaseURL, getGLBAIBaseURL } from '../env';

const ProductARViewer = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const platformQuery = queryParams.get('platform');
  const environmentQuery = queryParams.get('env');
  const aiQuery = queryParams.get('ai');
  const platform = platformQuery ? platformQuery : "aws";
  const env = environmentQuery ? environmentQuery : "staging";
  const isAIModel = aiQuery ? aiQuery : undefined;
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    setId(path.split('/').pop());
    console.log(id);
  }, []);

  const getUSDZUrl = () => {
    let link= ''
    if (isAIModel) {  
      link = getUSDZAIBaseURL(platform, env) + id + '.usdz';
      console.log(link);
    }
    else {
      link = getUSDZBaseURL(platform, env) + id + '.usdz';
    }
    return link;
  };

  const getGlbUrl = () => {
    let link= ''
    if (isAIModel) {
      link = getGLBAIBaseURL(platform, env) + id + '.glb';
    }
    else {
      link = getGLBBaseURL(platform, env) + id + '.glb';
    }
    return link;
  };

  const isARSupported = async () => {
    if (navigator.userAgent.includes("Android")) {
        return navigator.xr?.isSessionSupported('immersive-ar').then((supported) => supported) ?? false;
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        // For iOS, generally assume AR is supported if it's iOS 12+ for AR Quick Look support
        return parseInt(navigator.appVersion.match(/OS (\d+)_/)[1], 10) >= 12;
    }
    return false;
};

const getAndroidZUrl = () => {
    if(isARSupported()) {
        return `intent://arvr.google.com/scene-viewer/1.0?file=${getGlbUrl()}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`;
    }
    else {
        return getGlbUrl();
    }
}

  const openAr = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
          window.location.href = getUSDZUrl(); 
        }
        else if (/android/i.test(userAgent)) {
            window.location.href = getAndroidZUrl();   
        }
        else {
            window.location.href = getAndroidZUrl();
        }
    };

  useEffect(() => {
    if (id) {
      openAr();
    }
  }, [id]);

  return (
    <>
      <div className="ar-loader-container">
        {isLoading && (
          <div className="loading-text">
            <div>Loading AR Experience</div>
            <div className="loading-dots">
              <span className="dot-1">•</span>
              <span className="dot-2">•</span>
              <span className="dot-3">•</span>
              <span className="dot-4">•</span>
            </div>
          </div>
        )}
        <div className="ar-viewer-title">
          <span>
            <img 
              src="/img/ar.png" 
              alt="AR" 
              className="ar-icon"
            />
            ALL3D AR Viewer
          </span>
        </div>
      </div>
    </>
  );
};

export default ProductARViewer; 